import { Box, styled, Typography } from "@mui/material";

const LayerHeadingStyle = styled(Box)`
  position: relative;

  h1 {
    white-space: nowrap;
    word-break: keep-all;
    color: #050110;
    font-weight: 800;
    opacity: 0.6;
    background: radial-gradient(
      47.22% 976.49% at 50.46% 56.84%,
      #3868f0 0%,
      #3fccfa 100%
    );
    background-size: 200% 200%;

    -webkit-background-clip: text;
    -webkit-text-stroke: 3px transparent;
  }

  h4 {
    white-space: nowrap;
    word-break: keep-all;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2.3rem;
    font-weight: 800;
    background: linear-gradient(180deg, #0075ff 0%, #00ffff 128.41%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
`;

const LayerHeading = ({ children, ...props }) => {
  return (
    <LayerHeadingStyle {...props}>
      <Typography variant="h1" align="center" textTransform="uppercase">
        {children}
      </Typography>
      <Typography variant="h4" align="center" textTransform="uppercase">
        {children}
      </Typography>
    </LayerHeadingStyle>
  );
};

export default LayerHeading;
